const errors = {
  operatorEmpty: 'L\'operator ne peut être vide',
  fieldEmpty: 'Vous devez choisir un champ',
  canNotBeEmpty: 'Ce champ ne peut être vide',
  noOperand: 'Vous devez entrer une opérande',
};

export default errors;
